export const GET_CALENDAR_EVENTS_URL = '/calendar/events';
export const CREATE_CALENDAR_EVENT_URL = '/calendar/events';
export const UPDATE_CALENDAR_EVENT_URL = (id) => `/calendar/events/${id}`;
export const DELETE_CALENDAR_EVENT_URL = (id) => `/calendar/events/${id}`;
